import {Head, Link} from '@inertiajs/react';
import {PageProps} from '@/types';
import LandingPageHeader from "@/Pages/Landing/Partials/LandingPageHeader";
import HowItWorks, {HowItWorksProps} from "@/Pages/Landing/Partials/HowItWorks";
import GuestLayout from "@/Layouts/Guest/GuestLayout";
import useTranslations from "@/hooks/useTranslations";

export default function HardcodedSubtitles({}: PageProps) {
    const { __ } = useTranslations();

    const steps: {title: string, description: string}[] = __('extract-hardcoded.how_to.steps');

    return (
        <GuestLayout>
            <Head title={__('extract-hardcoded.title')}>
                <title>{__('extract-hardcoded.title')}</title>
                <meta name="description"
                      content={__('extract-hardcoded.meta_description')}/>
            </Head>
            <LandingPageHeader
                buttonText={__('extract-hardcoded.header.button_text')}
                title={__('extract-hardcoded.header.title')}
                description={__('extract-hardcoded.header.description')}
            />
            <div className="py-10"></div>
            <HowItWorks steps={__('extract-hardcoded.steps')} title={__('extract-hardcoded.steps_title')}/>
            <div className="py-6"></div>
            <div className="w-full lg:max-w-screen-xl mx-auto px-5">
                <div className="flex flex-col md:flex-row items-center justify-center space-x-4">

                    <div className="md:mr-10 lg:mr-40 flex-shrink-0">
                        <img alt={__('extract-hardcoded.image_alts.language_detection')}
                             className="object-contain md:w-[550px] shadow-md border-gray-300"
                             src="/img/select-language-screenshot.png"/>
                    </div>


                    <div className="text-center md:text-start mt-5 md:mt-0">
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{__('extract-hardcoded.features.auto_detect.title')}</h2>
                        <p className="text-gray-600 dark:text-gray-400">{__('extract-hardcoded.features.auto_detect.description')}</p>
                    </div>
                </div>
            </div>
            <div className="py-6"></div>
            <div className="w-full lg:max-w-screen-xl mx-auto px-5">
                <div className="flex flex-col md:flex-row-reverse items-center justify-center space-x-4 ">

                    <div className="md:mr-10 lg:ml-40 flex-shrink-0">
                        <img alt={__('extract-hardcoded.image_alts.subtitle_bounds')}
                             className="object-contain md:w-[550px] rounded-lg "
                             src="/img/detecting-video-subtitle-bounds.png"/>
                    </div>


                    <div className="text-center md:text-start mt-5 md:mt-0">
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{__('extract-hardcoded.features.subtitle_capture.title')}</h2>
                        <p className="text-gray-600 dark:text-gray-400">{__('extract-hardcoded.features.subtitle_capture.description')}</p>
                    </div>
                </div>
            </div>

            <div className="py-6"></div>
            <div className="w-full lg:max-w-screen-xl mx-auto px-5">
                <div className="flex flex-col md:flex-row items-center justify-center space-x-4">

                    <div className="md:mr-10 lg:mr-40 flex-shrink-0">
                        <img alt={__('extract-hardcoded.image_alts.extraction_files')}
                             className="object-contain md:w-[550px] shadow-md border-gray-300"
                             src="/img/subtitle-extraction-files.png"/>
                    </div>


                    <div className="text-center md:text-start mt-5 md:mt-0">
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{__('extract-hardcoded.features.fast_extraction.title')}</h2>
                        <p className="text-gray-600 dark:text-gray-400">{__('extract-hardcoded.features.fast_extraction.description')}</p>
                    </div>
                </div>
            </div>


            <section className="bg-gray-50 dark:bg-gray-800 py-14 my-10">
                <div className="lg:max-w-screen-xl mx-auto">
                    <div className="p-4 sm:p-8  bg-white dark:bg-gray-900 shadow sm:rounded-lg">
                        <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-8">{__('extract-hardcoded.how_to.title')}</h2>
                        <ol className="list-decimal list-inside space-y-4">
                            {
                                steps.map((step, index) => (
                                    <li key={index} className="text-gray-900 dark:text-gray-100">
                                        <strong className="font-bold text-gray-900 dark:text-gray-100">{step.title}</strong>
                                        <p className="text-gray-700 dark:text-gray-300">{step.description}</p>
                                    </li>
                                ))
                            }
                        </ol>
                    </div>
                </div>
            </section>
            <div className="flex flex-col items-center justify-center space-y-4">
                <Link
                    href={route('register')}
                >
                    <button
                        className="rounded text-lg  w-fit transition focus-visible:ring-2 ring-offset-2 ring-gray-200 px-5 py-2.5  hover:bg-gray-500 hover:text-white  border-2 border-gray-500 inline-flex  gap-1 items-center ">
                        {__('extract-hardcoded.cta.get_started')}
                    </button>
                </Link>
            </div>
        </GuestLayout>
    );
}
